"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccordianActions;
(function (AccordianActions) {
    AccordianActions["Toggled"] = "Toggled";
})(AccordianActions || (AccordianActions = {}));
exports.default = AccordianActions;
